import type { UserRole } from '@/types/user';
// import Dashboard from '@/pages/Dashboard';
// import PublicProfile from '@/pages/PublicProfile'; // Add this import

const baseUrl = import.meta.env.VITE_APP_URL || 'https://dev.skillsture.io';

export interface MenuItem {
  label: string;
  path: string;
  roles?: UserRole[]; // If undefined, show to all roles
  authRequired?: boolean; // If true, only show when authenticated
  publicOnly?: boolean; // If true, only show when not authenticated
  external?: boolean; // If true, This is external
  showLayout?: boolean; // Add this new property
  component?: React.ComponentType; // Optional component name for route mapping
  action?: 'logout' | 'login' | 'signup'; // Add action type for special behaviors
}

export const menuItems: MenuItem[] = [
  // Public menu items (visible to all)
  {
    label: 'Dashboard',
    path: '/dashboard',
    authRequired: true,
    showLayout: true,
    // component: Dashboard,
  },
  {
    label: 'MySKILLSTURE AI',
    path: `https://skillsture.io/myskillsture-ai`,
    external: true,
    showLayout: false,
    // No authRequired - visible to everyone
  },
  {
    label: 'Skillstree',
    path: '/skillstree',
    // roles: ['unsubscribed', 'trial', 'plus'], // Only for logged-in users
    authRequired: true,
    showLayout: true,
  },
  {
    label: 'Online Coaching',
    path: '/online-coaching',
    // roles: ['trial', 'plus'], // Only for trial and plus users
    authRequired: false,
    showLayout: true,
  },
  {
    label: 'Professional Networking',
    path: '/professional-networking',
    // roles: ['plus'], // Only for plus users
    authRequired: false,
    showLayout: true,
  },
  // Add more menu items as needed
];

export const profileItems: MenuItem[] = [
  {
    label: 'Profile',
    path: '/profile',
    authRequired: true, // Changed to true - only authenticated users
    showLayout: true,
  },
  {
    label: 'Achievements',
    path: '/achievements',
    authRequired: true, // Changed to true - only authenticated users
    showLayout: true,
  },
  // {
  //   label: 'Settings',
  //   path: '/settings',
  //   authRequired: true, // Changed to true - only authenticated users
  //   showLayout: true,
  // },
  {
    label: 'Sign out',
    path: '/', // Redirect to home after logout
    authRequired: true, // Only show when authenticated
    showLayout: true,
    action: 'logout', // Special action identifier
  },
];

export const guestItems: MenuItem[] = [
  {
    label: 'Sign in',
    path: '/login',
    authRequired: false,
    showLayout: false, // No layout for login page
  },
  {
    label: 'Sign up',
    path: '/signup',
    authRequired: false,
    showLayout: false, // No layout for signup page
  },
  // {
  //   label: 'Public Profile',
  //   path: '/profile/:username',
  //   authRequired: false,
  //   showLayout: true,
  //   component: PublicProfile,
  // },
];

// Combine all routes for App configuration
export const appRoutes: MenuItem[] = [
  // Add your main page (might not be in menuItems)
  {
    label: 'Home',
    path: '/',
    showLayout: true,
  },
  ...menuItems,
  ...guestItems,
  // Add other routes that might not be in navigation menus
  {
    label: 'Profile',
    path: '/profile',
    showLayout: true,
  },
  // {
  //   label: 'Public Profile',
  //   path: '/profile/:username',
  //   authRequired: false,
  //   showLayout: true,
  //   component: PublicProfile, // Add the component reference
  // },
];

export const publicRoutes = [
  '/professional-networking',
  '/online-coaching',
  // '/skillstree',
  '/login',
  '/signup',
  '/forgot-password', 
  '/verify-otp',
  '/reset-password',
  '/verify-email',
  '/plan-selection',
  '/welcome',
  '/', // if home is public
];

export const isPublicRoute = (pathname: string): boolean => {
  return publicRoutes.some(route => 
    pathname === route || 
    pathname.startsWith(route + '/') ||
    // Handle dynamic public routes like public profiles
    pathname.match(/^\/profile\/[^/]+$/) // /profile/username
  );
};